function updateRangeSlider(productSlider, sliderContainer) {
  const rangeSlider = sliderContainer.querySelector('#dynamic-range-slider');
  if (rangeSlider) {
    const scrollLeft = productSlider.scrollLeft;
    const clientWidth = productSlider.clientWidth;
    const scrollWidth = productSlider.scrollWidth;

    // Tránh lỗi chia cho 0 nếu không có gì để scroll
    if (scrollWidth <= clientWidth) {
      rangeSlider.style.left = '0%';
      rangeSlider.style.width = '100%';
      return;
    }

    // 1. Tính chiều rộng của thanh trượt (thumb) dựa trên tỷ lệ nội dung có thể thấy
    const thumbWidthPercent = (clientWidth / scrollWidth) * 100;
    rangeSlider.style.width = `${thumbWidthPercent}%`;

    // 2. Tính quãng đường scroll tối đa
    const maxScrollLeft = scrollWidth - clientWidth;

    // 3. Tính phần trăm đã scroll (từ 0 đến 1)
    const scrollPercent = scrollLeft / maxScrollLeft;

    // 4. Tính vị trí left mới. Vị trí tối đa của left là (100% - chiều rộng của thumb).
    // Ta nhân % đã scroll với vị trí tối đa này.
    const newLeft = scrollPercent * (100 - thumbWidthPercent);
    rangeSlider.style.left = `${newLeft}%`;
  }
}

function createSliderContainer(productSlider) {
  const sliderContainer = document.createElement('div');
  sliderContainer.id = 'slider-container';
  const rangeSlider = document.createElement('div');
  rangeSlider.id = 'dynamic-range-slider';
  sliderContainer.appendChild(rangeSlider);
  productSlider.parentElement.appendChild(sliderContainer);

  productSlider.addEventListener('scroll', () => updateRangeSlider(productSlider, sliderContainer));
  window.addEventListener('resize', () => updateRangeSlider(productSlider, sliderContainer)); // Thêm event resize để cập nhật khi cửa sổ thay đổi
  updateRangeSlider(productSlider, sliderContainer);
}

// Giữ nguyên phần code DOMContentLoaded của bạn
document.addEventListener('DOMContentLoaded', () => {
  const productSlider = document.querySelector('product-slider');
  if (productSlider) {
    createSliderContainer(productSlider);

    // Ngưỡng chiều rộng để thay đổi layout
    const breakpoint = 1067;

    // Hàm để xử lý việc thay đổi layout
    const handleLayoutChange = () => {
      const isDesktop = window.innerWidth > breakpoint;

      // Tìm slider-desktop đã có sẵn hay chưa
      const sliderDesktop = productSlider.querySelector('.slider-desktop');

      // --- TRƯỜNG HỢP 1: Chuyển sang layout DESKTOP ---
      // Điều kiện: màn hình rộng hơn breakpoint VÀ slider-desktop chưa được tạo
      if (isDesktop && !sliderDesktop) {
        console.log('Chuyển sang layout Desktop...');
        // 1. Tạo một element mới (div) để chứa các slide
        const newSliderDesktop = document.createElement('div');
        newSliderDesktop.classList.add('slider-desktop');

        // 2. Lấy danh sách tất cả các con của productSlider,
        //    chuyển thành mảng và bỏ đi phần tử đầu tiên (slice(1))
        const childrenToMove = Array.from(productSlider.children).slice(1);

        // 3. Di chuyển từng phần tử con vào trong newSliderDesktop
        childrenToMove.forEach(child => {
          newSliderDesktop.appendChild(child);
        });

        // 4. Thêm newSliderDesktop vào cuối của productSlider
        const newSliderDesktopWrapper = document.createElement('div');
        newSliderDesktopWrapper.classList.add('slider-desktop-wrapper');
        newSliderDesktopWrapper.appendChild(newSliderDesktop);
        productSlider.appendChild(newSliderDesktopWrapper);

        const buttons = document.createElement('div');
        buttons.innerHTML = `
          <div class="slider-desktop-buttons">
            <button type="button" class="slider-desktop-button slider-desktop-button--prev" name="previous" aria-label="Previous" disabled>
              <svg class="icon icon-arrow-left" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.13281 6.33332L6.13281 10.0667L3.33281 8.19998L6.13281 6.33332Z" fill="#2A6045"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6661 8.66673H6.13281V7.7334H12.6661V8.66673Z" fill="#2A6045"></path></svg>
            </button>
            
            <button type="button" class="slider-desktop-button slider-desktop-button--next" name="next" aria-label="Next">
              <svg class="icon icon-arrow-right" width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.86719 10.1066V6.37329L12.6672 8.23996L9.86719 10.1066Z" fill="#2A6045"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.86927 8.70665H3.33594V7.77332H9.86927V8.70665Z" fill="#2A6045"></path></svg>
            </button>
          </div>`
        buttons.querySelector('.slider-desktop-button--next').addEventListener('click', () => {
          newSliderDesktop.scrollBy({
            left: newSliderDesktop.clientWidth,
            behavior: 'smooth'
          });
          updateButtonState(newSliderDesktop.scrollLeft + newSliderDesktop.clientWidth);
        });
        buttons.querySelector('.slider-desktop-button--prev').addEventListener('click', () => {
          newSliderDesktop.scrollBy({
            left: -newSliderDesktop.clientWidth,
            behavior: 'smooth'
          });
          updateButtonState(newSliderDesktop.scrollLeft - newSliderDesktop.clientWidth);
        });

        newSliderDesktopWrapper.appendChild(buttons);

        function updateButtonState(nextScrollLeft) {
          buttons.querySelector('.slider-desktop-button--prev').disabled = nextScrollLeft < newSliderDesktop.clientWidth / 2;
          buttons.querySelector('.slider-desktop-button--next').disabled = nextScrollLeft + newSliderDesktop.clientWidth * 1.5 >= newSliderDesktop.scrollWidth;
        }

        createSliderContainer(newSliderDesktop);

        newSliderDesktop.addEventListener('scroll', () => {
          updateButtonState(newSliderDesktop.scrollLeft);
        });
      }
      // --- TRƯỜNG HỢP 2: Hoàn tác, quay về layout MOBILE ---
      // Điều kiện: màn hình hẹp hơn breakpoint VÀ slider-desktop đang tồn tại
      else if (!isDesktop && sliderDesktop) {
        console.log('Hoàn tác về layout Mobile...');
        // 1. Lấy tất cả các con bên trong sliderDesktop
        const childrenToRevert = Array.from(sliderDesktop.children);

        // 2. Di chuyển từng phần tử trở lại làm con trực tiếp của productSlider
        childrenToRevert.forEach(child => {
          productSlider.appendChild(child);
        });

        // 3. Xóa bỏ element slider-desktop đã rỗng
        sliderDesktop.parentElement.remove();
      }
    };

    // Lắng nghe sự kiện resize của cửa sổ trình duyệt
    // Khi người dùng thay đổi kích thước cửa sổ, hàm handleLayoutChange sẽ được gọi
    window.addEventListener('resize', handleLayoutChange);

    // Gọi hàm một lần ngay khi tải trang để áp dụng layout đúng từ đầu
    handleLayoutChange();
  }
});